export default __webpack_public_path__ + "static/media/speed-map.aba21582.png";